import { useLazyGetSSOUrlQuery } from 'api/authentication-api';

export const useSingleSignOnRedirect = () => {
  const [getSSOUrl] = useLazyGetSSOUrlQuery();

  return async email => {
    const [, domain] = (email || '').trim().toLowerCase().split('@');
    if (!domain) return false;

    const { data: url } = await getSSOUrl(domain);
    if (!url) return false;

    window.location.replace(url);
    return true;
  };
};
